export default function ThumbNail() {
  return (
    <svg
      width="80"
      height="45"
      viewBox="0 0 1280 720"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ borderRadius: "6px" }}
    >
      <rect width="1280" height="720" fill="#280653" />
      <path
        d="M232.53 449.369C363.414 548.866 444.899 443.993 447.416 395.52L399.593 392.968C387.511 454.197 297.972 459.574 262.734 416.203L232.53 449.369Z"
        fill="url(#paint0_linear_4996_18299)"
      />
      <path
        d="M399.593 362.351C399.593 391.94 375.928 415.926 346.736 415.926C317.544 415.926 293.879 391.94 293.879 362.351C293.879 332.762 317.544 308.776 346.736 308.776C375.928 308.776 399.593 332.762 399.593 362.351Z"
        fill="url(#paint1_radial_4996_18299)"
      />
      <path
        d="M361.831 262.857C388.054 267.69 394.403 282.892 392.782 298.198C390.649 318.345 373.8 334.146 354.28 339.618C351.924 340.278 349.652 340.809 347.482 341.227C333.749 343.878 319.449 341.247 305.549 342.795C233.829 350.783 233.522 410.223 243.532 441.442C226.638 428.6 221.063 401.707 220.098 379.422C219.385 362.954 222.556 346.442 229.375 331.433C256.776 271.122 312.322 253.733 361.831 262.857Z"
        fill="url(#paint2_linear_4996_18299)"
      />
      <path
        d="M298.902 390.414C387.501 408.783 419.718 343.642 424.752 308.776C467.038 355.718 447.406 413.375 432.303 436.336C419.718 418.478 397.065 400.619 369.378 415.926C355.048 423.849 339.946 432.91 328.569 439.933C318.911 445.895 308.144 450.668 296.843 449.591C281.626 448.142 265.085 441.19 263.664 421.029C261.65 392.455 286.317 388.713 298.902 390.414Z"
        fill="url(#paint3_linear_4996_18299)"
      />
      <path
        d="M869.443 360.428V446.697H893.685V360.428H869.443Z"
        fill="white"
      />
      <path
        d="M716.289 327.034V446.697H740.532V327.034H716.289Z"
        fill="white"
      />
      <path
        d="M605.424 332.927V354.535H571.845V446.697H547.439V354.535H513.86V332.927H605.424Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M674.28 360.428H696.721V446.697H674.28V437.202C668.056 444.569 659.047 448.825 647.745 448.825C622.847 448.825 604.829 429.345 604.829 403.644C604.829 377.78 622.847 359.937 647.745 359.937C659.047 359.937 668.056 363.866 674.28 370.905V360.428ZM651.184 427.38C664.452 427.38 673.461 417.722 673.461 403.644C673.461 389.566 664.452 379.745 651.184 379.745C638.244 379.745 628.908 389.894 628.908 403.644C628.908 417.395 638.244 427.38 651.184 427.38Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M834.192 446.697L826.166 422.306H783.905L775.879 446.697H751.8L790.129 332.927H819.777L858.107 446.697H834.192ZM819.614 402.498L805.035 358.464L790.457 402.498H819.614Z"
        fill="white"
      />
      <path
        d="M936.24 368.777C942.136 362.557 950.818 358.3 960.973 358.3V381.054C946.231 381.054 937.55 387.766 937.55 399.225V446.697H913.308V360.428H936.24V368.777Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M967.634 403.644C967.634 429.345 986.962 448.825 1014.32 448.825C1041.51 448.825 1061 429.345 1061 403.644C1061 377.78 1041.51 358.464 1014.32 358.464C986.962 358.464 967.634 377.78 967.634 403.644ZM1036.76 403.481C1036.76 417.395 1027.58 427.217 1014.48 427.217C1001.05 427.217 992.04 417.395 992.04 403.644C992.04 389.73 1001.05 380.072 1014.48 380.072C1027.91 380.072 1036.76 389.73 1036.76 403.481Z"
        fill="white"
      />
      <path
        d="M839.721 264.077C839.772 263.977 839.915 263.977 839.966 264.077C842.632 269.353 846.924 273.725 852.172 276.449C852.27 276.5 852.27 276.641 852.172 276.692C846.924 279.416 842.632 283.789 839.966 289.064C839.915 289.164 839.772 289.164 839.721 289.064C837.055 283.789 832.763 279.416 827.515 276.692C827.417 276.641 827.417 276.5 827.515 276.449C832.763 273.725 837.055 269.353 839.721 264.077Z"
        fill="#7F56D9"
      />
      <path
        d="M878.463 230.147C878.493 230.087 878.579 230.087 878.609 230.147C881.287 235.498 885.635 239.929 890.959 242.666C891.018 242.696 891.018 242.781 890.959 242.812C885.635 245.548 881.287 249.979 878.609 255.33C878.579 255.39 878.493 255.39 878.463 255.33C875.784 249.979 871.436 245.548 866.112 242.812C866.053 242.781 866.053 242.696 866.112 242.666C871.436 239.929 875.784 235.498 878.463 230.147Z"
        fill="#7F56D9"
      />
      <path
        d="M883.768 294.203C886.706 300.16 891.498 305.004 897.425 308.007L903.587 311.13C903.784 311.23 903.784 311.512 903.587 311.612L897.425 314.734C891.498 317.738 886.706 322.582 883.768 328.539L880.651 334.858C880.552 335.059 880.266 335.059 880.167 334.858L877.05 328.539C874.112 322.582 869.32 317.738 863.393 314.734L857.232 311.612C857.034 311.512 857.034 311.23 857.232 311.13L863.393 308.007C869.32 305.004 874.112 300.16 877.05 294.203L880.167 287.883C880.266 287.683 880.552 287.683 880.652 287.883L883.768 294.203Z"
        fill="#7F56D9"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4996_18299"
          x1="262.886"
          y1="433.161"
          x2="443.442"
          y2="454.885"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5A35B2" stop-opacity="0" />
          <stop offset="0.476722" stop-color="#5A35B2" />
          <stop offset="1" stop-color="#D72D74" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_4996_18299"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(346.736 362.351) rotate(90) scale(53.5754 52.8572)"
        >
          <stop stop-color="#8C45CA" />
          <stop offset="1" stop-color="#3D1C5B" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_4996_18299"
          x1="219.938"
          y1="314.587"
          x2="455.228"
          y2="348.105"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5A35B2" />
          <stop offset="1" stop-color="#FA4F96" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4996_18299"
          x1="263.548"
          y1="350.916"
          x2="512.873"
          y2="400.025"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5A35B2" />
          <stop offset="1" stop-color="#FA4F96" />
        </linearGradient>
      </defs>
    </svg>
  );
}
